import React from "react";

export default function Footer() {
  return (
    <footer>
      This project was coded by{" "}
      <a href="https://github.com/allieallenn">Alicia Allen</a> and is{" "}
      <a href="https://github.com/allieallenn/weather-app-react">
        open-sourced on GitHub
      </a>
    </footer>
  );
}
